import React from 'react';

import {Events} from 'src/analytics';
import {CATEGORY, EDITORIAL, PODCAST} from 'src/routes/paths';
import {ChiefLogo} from 'src/svgs/chiefLogo';

import {SanityCategory, SanityEditorial, SanityLabelledImage, Maybe} from 'types/generated';

interface GridCardSmallProps {
  article: Maybe<SanityEditorial>;
  titleClasses?: string;
}

export const GridCardSmall: React.FC<GridCardSmallProps> = ({article, titleClasses}: GridCardSmallProps) => {
  const cardImgSrc = article?.heroImage ? article?.heroImage.asset?.url : null;
  const cardImgAlt = article?.heroImage && article?.heroImage.altText ? article?.heroImage.altText : '';

  const slug = article?.slug?.current ?? '';
  const cardLink = `${article?.isPodcast == true ? PODCAST : EDITORIAL}/${slug}`;

  const handleImageClick = (item: string) => () => {
    Events.didClickImage({
      item,
      pageLocation: 'gridCard',
      sectionName: 'Index',
      linkUrl: `${cardLink}`,
    });
  };
  const handleTitleClick = (item: string) => () => {
    Events.didClickArticle({
      item,
      pageLocation: 'gridCard',
      sectionName: 'Index',
      linkUrl: `${cardLink}`,
    });
  };
  return (
    <div className="col-span-full flex">
      <a href={cardLink} className="col-span-2 w-[140px] h-[105px] md:w-[190px] md:h-[130px]">
        {cardImgSrc ? (
          <img className="object-cover w-full h-full" src={cardImgSrc} alt={cardImgAlt} />
        ) : (
          <div className="w-full h-full object-cover bg-black flex items-center justify-center">
            <ChiefLogo classes={'mb-2 lg:mb-0 h-[18px] lg:w-25 lg:h-[8%] fill-light-gold'} />
          </div>
        )}
      </a>

      <div className="w-7/12  md:w-8/12 ml-5">
        {!!article?.isSponsored && (
          <span className={`type-eyebrow ${titleClasses ?? 'text-green-dark'} block`}>Sponsored Post</span>
        )}

        {!!article?.editorialCategory?.slug?.current && !article?.isSponsored ? (
          <a
            href={`${CATEGORY}/${article?.editorialCategory.slug.current}`}
            className={`block type-eyebrow md:-mt-1 mb-2 ${titleClasses ?? 'text-green-dark'} link-eyebrow`}
          >
            {article.editorialCategory.title}
          </a>
        ) : article?.category && !article?.isSponsored ? (
          <span className={`block type-eyebrow md:-mt-1 mb-2${titleClasses ?? 'text-green-dark'}`}>
            {article?.category}
          </span>
        ) : null}

        <h4 className="type-theta">
          {article?.slug?.current ? (
            <a href={cardLink} className={`${titleClasses ?? 'text-green-dark'} link-text`}>
              {article?.title}
            </a>
          ) : (
            <span>{article?.title}</span>
          )}
        </h4>

        {article?.isSponsored && article?.sponsorship?.clientName ? (
          <span className="type-xs-p mt-1 text-lighter-gray block">
            Presented by {article?.sponsorship?.clientName}
          </span>
        ) : null}
      </div>
    </div>
  );
};
